import { isCyberCoverageValid } from '../components/CyberInsurance/CyberInsurance.config';
import { isEPLICoverageValid } from '../components/EPLI/EPLI.config';
import { isLiquorLiabilityValid } from '../components/LiquorLiability/LiquorLiability.config';
import { isContractorToolsValid } from '../components/ContractorTools/ContractorTools.config';
import { isDamagesToPremisesRentedValid } from '../components/DamagesToPremisesRented/DamagesToPremisesRented.config';
import { EndorsementKey } from '../types';
import { selectCheckedEndorsements } from '../../../selectors/application';
import { isWorkplaceViolenceCoverageValid } from '../components/WorkplaceViolence/WorkplaceViolence.config';

export {
  isCyberCoverageValid,
  isWorkplaceViolenceCoverageValid,
  isEPLICoverageValid,
  isLiquorLiabilityValid,
  isContractorToolsValid,
  isDamagesToPremisesRentedValid,
};

export const endorsementValidators: Record<string, (state: ReduxState) => boolean> = {
  [EndorsementKey.CyberCoverage]: isCyberCoverageValid,
  [EndorsementKey.WorkplaceViolenceCoverage]: isWorkplaceViolenceCoverageValid,
  [EndorsementKey.EpliCoverage]: isEPLICoverageValid,
  [EndorsementKey.LiquorLiabilityEndorsement]: isLiquorLiabilityValid,
  [EndorsementKey.ContractorsInstallationAndTools]: isContractorToolsValid,
  [EndorsementKey.LimitDamagePremRented]: isDamagesToPremisesRentedValid,
};

export const areAllEndorsementsValid = (state: ReduxState) => {
  const checkedEndorsements = selectCheckedEndorsements(state);
  return checkedEndorsements.every((key) => {
    const isValid = endorsementValidators[key];
    if (!isValid) return true;
    return isValid(state);
  });
};
